module.exports = __webpack_public_path__ + "img/close-button.84251b2e.svg";